export const GERMAN_TRANSLATIONS = {
  text: {
    web_title: 'SMARTZ®-DASHBOARD',
    authentication: 'Authentifizierung',
    username: 'Benutzername',
    password: 'Passwort',
    sign_in: 'Anmelden',
    username_required: 'Benutzername ist erforderlich',
    password_required: 'Passwort ist erforderlich',
    invalid_credential: 'Falscher Benutzername oder falsches Passwort',
    forgot_password: 'Passwort vergessen',
    change: 'Änderung',
    well_being: 'Wohlbefinden',
    warnings: 'Warnungen',
    no_patients_to_change: 'Keine Patienten zum Wechseln',
    no_patients: 'Keine Patienten',
    logout: 'Abmelden',
    lost_connection: 'Verbindung mit Smartz®-Cloud verloren',
    check_connection: 'Bitte überprüfen Sie Ihre Internetverbindung',
    trying_to_reconnect: 'Es wird versucht, die Verbindung wiederherzustellen',
    pad_time: 'Zeit im IKM',
    red_time: 'Zeit in Rot',
    position: 'Position',
    time: 'Zeit',
    time_in_position: 'Zeit in Position',
    sitting: 'Sitzend',
    standing: 'Stehend',
    left: 'Links',
    right: 'Rechts',
    lying: 'Liegend',
    unknown: 'Unbekannt',
    wet_surface: 'Nasse Oberfläche',
    out_of_range: 'Außerhalb des Bereichs',
    low_battery: 'Niedriger Batteriestand',
    disconnected: 'Getrennt',
    unexpected_problem: 'Unerwartetes Problem',
    ok: 'Okay',
    change_soon: 'Demnächst wechseln',
    change_pad: 'IKM wechseln',
    languages: 'Sprachen',
    dashboard: 'DASHBOARD',
    pad_fill_profile: 'IKM-Füllstandprofil',
    goal: 'ZIELVORGABEN',
    report: 'BERICHT',
    manage: 'VERWALTEN',
    individual: 'Individuell',
    group: 'Gruppe',
    action_required: 'MAẞNAHME ERFORDERLICH',
    monitor: 'MONITORING',
    pod_unclipped: 'IKM nicht angebracht',
    check_patient: 'Patient überprüfen',
    check_pad: 'IKM überprüfen',
    check_time_in_pad: 'Zeit im IKM überprüfen',
    check_position: 'Position überprüfen',
    check_temperture: 'Temperatur messen',
    check_pad_fill_profile: 'IKM-FÜLLSTANDPROFIL ÜBERPRÜFEN',
    instructions: 'Anleitung',
    time_in_pos: 'Zeit in Position',
    pad_capacity: 'IKM-Kapazität',
    time_in_pad: 'Zeit im IKM',
    ambient: 'Umgebung',
    time_at_temp: 'Zeit bei Temperatur',
    pad_wet: 'IKM NASS',
    pad_dry: 'IKM TROCKEN',
    daily_pad_fill: 'Tägliche IKM-Füllung',
    seven_day_trend: 'Sieben-Tage-Trend',
    daytime: 'Tageszeit',
    nighttime: 'Nachtzeit',
    volume_in_pad: 'Volumen im IKM',
    pad_fill_summary: 'ÜBERSICHT ÜBER DIE IKM-FÜLLUNG',
    daily_average: 'Täglicher Durchschnitt',
    today: 'Heute',
    capacity: 'Kapazität',
    pads_used: 'Benutzte IKM',
    per_day: 'pro Tag',
    average: 'Durchschnitt',
    leakage_detected: 'Auslaufen erkannt',
    times: 'Zeiten',
    pad_cycles: 'IKM-Zyklen',
    time_in_a_pos: 'Zeit in einer Position',
    max_time_in_a_pos: 'Maximale Zeit in Position',
    re_positioning: 'Neupositionierung',
    time_day: 'Uhrzeit/Tag',
    temperature: 'Temperatur',
    typical_temp: 'Typische Temperatur',
    temp_range: 'Temperaturbereich',
    charts: 'BERICHTE',
    pad_fill_profile_for_7_days: 'IKM-Füllprofil – Sieben-Tage-Trend',
    daily_total: 'Gesamt täglich',
    accuracy: 'Genauigkeit',
    last_24_hours: '24 Stunden ab dem ausgewählten Datum',
    volume_voided_in_pad: 'Im IKM entleertes Volumen',
    body: 'Körper',
    wetness_usage: 'Nässe/Verwendung',
    environment_body: 'Umgebungstemperatur',
    activity: 'Aktivität',
    lift_style: 'Art des Anhebens',
    skin_care: 'IKM Tragedauer',
    skin_care_management: 'IKM Tragedauer-Management',
    workflow: 'Workflow',
    workflow_efficiency: 'Workflow-Effizienz',
    set_maximum_voiding_volume_into_pad:
      'Maximales Entleerungsvolumen im IKM festlegen',
    less_void: 'WENIGER ENTLEERUNG',
    more_void: 'MEHR ENTLEERUNG',
    day: 'TAG',
    night: 'NACHT',
    day_time: 'Tageszeit',
    night_time: 'Nachtzeit',
    average_period: 'Durchschnittlicher Zeitraum',
    default: 'STANDARD',
    desire_position: 'Zeit in Position',
    time_in_a_position: 'Zeit in einer Position',
    desire_temperature: 'Umgebungstemperatur des Pods',
    coloer: 'KÄLTER',
    hotter: 'HEIẞER',
    desire_skin_care: 'IKM Tragedauer',
    off: 'AUS',
    standard_care: 'STANDARDPFLEGE',
    extra_care: 'ZUSÄTZLICHE PFLEGE',
    more_time_in_wet_pad: 'MEHR ZEIT IM NASSEN IKM',
    more_time_in_a_pos: 'MEHR ZEIT IN EINER POSITION',
    less_time_in_wet_pad: 'WENIGER ZEIT IM NASSEN IKM',
    less_time_in_a_pos: 'WENIGER ZEIT IN EINER POSITION',
    override:
      'Diese Vorgabe setzt die Zielvorgaben für das IKM und den Körper außer Kraft',
    check_pod: 'Pod überprüfen',
    check_pod_and_reclip: 'Pod überprüfen und erneut anbringen',
    lost_connect: 'Verbindung verloren',
    voids_into_pad_hours: 'Entleert sich in 96 Stunden in das IKM',
    chart_date: 'Datum des Diagramms',
    fullscreen: 'Vollbild',
    normalscreen: 'Normale Ansicht',
    void_chart: 'Miktionsprotokoll',
    voids_into_pad: 'Entleerungen in das IKM',
    pad_fill_trend: 'IKM-Fülltrend',
    legend: 'LEGENDE',
    new_pad: 'Neues IKM',
    void_in_pad: 'Entleerung in das IKM',
    share: 'Teilen',
    print: 'Drucken',
    position_profile: 'Positionsprofil',
    body_position: 'Körperposition',
    body_positions_over_96_hours: 'Körperpositionen über 96 Stunden',
    lying_on_back: 'Liegend – auf dem Rücken',
    lying_on_front: 'Liegend – auf dem Bauch',
    lying_left_side: 'Liegend – auf der linken Seite',
    lying_right_side: 'Liegend – auf der rechten Seite',
    standing_walking: 'Stehend/Gehend',
    stats: 'Statistiken',
    pad_used: 'IKM_benutzt',
    max: 'Max.',
    surrounding_temperature: 'UMGEBUNGSTEMPERATUR',
    temp: 'Temperatur',
    avg: 'Durchschnitt',
    name: 'Name',
    provider: 'Anbieter',
    purpose: 'Zweck',
    expiry: 'Ablaufdatum',
    type: 'Typ',
    frequently_asked_questions: 'Häufig gestellte Fragen (FAQ)',
    information_for_use: 'Anwendungsinformationen',
    data_privacy: 'Datenschutz',
    eula: 'EULA',
    about: 'Über uns',
    settings: 'Einstellungen',
    save: 'Speichern',
    version: 'Version',
    support: 'Support',
    close: 'Schließen',
    copyright:
      'Copyright (C) 2022 Smartz Operations Limited. Alle Rechte vorbehalten',
    smartz_devices: 'Smartz®-Geräte',
    monitor_smartz_device_operation: 'Smartz®-Gerätebetrieb überwachen',
    last_seen: 'Zuletzt gesehen',
    battery: 'Batterie',
    ago: 'vor',
    date_rate: 'Stichtag',
    online: 'Online',
    singnal: 'Signal',
    temperature_goal: 'TEMPERATURVORGABE',
    data_privacy_desc: 'Einwilligung und personenbezogene Daten verwalten',
    organisation: 'ORGANISATION',
    organisation_desc: 'Gruppeneinstellungen verwalten',
    my_account: 'Mein Konto',
    my_account_desc: 'Kontoeinstellungen verwalten',
    consent: 'Einwilligung',
    marketing_comm: 'Marketing, Kommunikation und Werbeaktionen',
    consent_desc:
      'IKM-Hersteller und -Vertreiber können personenbezogene Daten für Marketing- und Werbezwecke verwenden. Das/die mit diesem Patienten verbundene(n) Benutzerkonto/Benutzerkonten kann/können mitunter per E-Mail gesendet werden. In diesem Fall kann die E-Mail-Adresse des Benutzers an Dritte weitergegeben werden.',
    data_management: 'Datenmanagement',
    Permanently_delete_account: 'Dieses Benutzerkonto endgültig löschen',
    permanently_delete_client: 'Diesen Client endgültig löschen',
    data_management_desc:
      'Das Konto ist nicht mehr verfügbar, und alle Daten im Konto werden endgültig gelöscht.',
    how_can_i_export:
      'Wie kann ich meine Kontoinformationen exportieren und sichern?',
    save_preference: 'EINSTELLUNG SPEICHERN',
    delete_account_data: 'KONTO UND DATEN LÖSCHEN',
    date_time_settings: 'Einstellungen von Datum und Uhrzeit',
    morning_time: 'Vormittags',
    night_time_label: 'Nachts',
    time_format: 'Zeitformat',
    date_format: 'Datumsformat',
    goal_text: 'Vorgabe',
    day_goal: 'Vorgabe für den Tag',
    night_goal: 'Vorgabe für die Nacht',
    check_battery: 'BATTERIE ÜBERPRÜFEN',
    reminders: 'Erinnerungen',
    update_data_privacy_consent:
      'Einwilligung zur Datenschutzerklärung aktualisieren',
    update: 'Aktualisieren',
    user: 'Benutzer',
    last_updated: 'Zuletzt aktualisiert',
    action: 'Maßnahme',
    delete_confirm: 'Möchten Sie das wirklich löschen?',
    cancel: 'Abbrechen',
    lost_internet_connection: 'INTERNETVERBINDUNG VERLOREN',
    check_setting:
      'Bitte überprüfen Sie Ihre Interneteinstellungen und -verbindungen',
    authentication_required: 'Authentifizierung erforderlich',
    account_details_have_changed: 'Kontoangaben haben sich geändert',
    date: 'Datum',
    no_pod_assigned: 'Kein Pod zugewiesen',
    monitoring_is_not:
      'Monitoring ist nicht verfügbar, da kein Smartz®-Pod zugewiesen wurde ',
    assign_a_pod: 'Zuweisen eines Pods zur',
    on_the_smartz_monitor_app:
      'Smartz®-Monitoring-App, um die Monitoring zu aktivieren.',
    see: 'Siehe',
    delete: 'Löschen',
    keep_in_mind_delete_data:
      'Bitte beachten Sie, dass das Löschen des Benutzerkontos und der personenbezogenen Daten endgültig ist.',
    you_able_to_delete_data: 'Sie sind dabei,',
    account_and_data: 'dieses Konto und die Daten',
    this: ' zu löschen',
    average_time_in_pad: 'Durchschnittliche Zeit im IKM',
    average_time_in_position: 'Durchschnittliche Zeit in Position',
    repositioning_24h: 'Neupositionierung 24 h',
    last_7_day_period: 'Letzter 7-Tage-Zeitraum',
    admin: 'ADMIN',
    administraive_settings: 'Administrative Einstellungen',
    group_data_rentenion: 'Aufbewahrung von Gruppendaten',
    maximum_inactivity_data_retention_period:
      'Maximale Aufbewahrungsfrist für inaktive Daten',
    group_data_rentenion_desc:
      'Personenbezogene Daten aller Benutzer und Patienten innerhalb dieser Gruppe werden entfernt, wenn der Inaktivitätszeitraum erreicht wurde.',
    data_rentenion_detail:
      'Die Bedingung für Inaktivität lautet wie folgt:<br>- Der Pod ist dem Patienten für einen bestimmten Zeitraum nicht zugewiesen.<br>- Der Pod ist dem Patienten zugewiesen, überträgt aber für einen bestimmten Zeitraum keine Daten an Smartz® -Apps.<br>- Der Benutzer hat sich für einen bestimmten Zeitraum nicht angemeldet.',
    months: 'Monate',
    user_roles: 'Benutzerrollen',
    users: 'Benutzer',
    role: 'Rolle',
    filter_by_group_or_users: 'nach Gruppe oder Benutzern filtern',
    urine_conversion_feature: 'Urin-Umwandlungsfunktion',
    use_urine_transform: 'Urintransformation verwenden',
    system_data_rentenion: 'Aufbewahrung von Systemdaten',
    system_data_rentenion_desc:
      'Personenbezogene Daten aller Benutzer und Patienten innerhalb dieses Systems werden entfernt, wenn der Inaktivitätszeitraum erreicht wurde.',
    reset_password: 'Passwort zurücksetzen',
    new_password: 'Neues Passwort',
    confirm_password: 'Passwort bestätigen',
    password_inconsistent: 'Das Passwort ist unstimmig',
    edit: 'bearbeiten',
    edit_roles: 'Rolle bearbeiten',
    available_roles: 'Verfügbare Rollen',
    assigned_roles: 'Zugewiesene Rollen',
    role_list: 'Liste der Rollen',
    role_name: 'Bezeichnung der Rolle',
    role_permissions: 'Berechtigung der Rolle',
    level_1_module: 'Level 1 Modul',
    level_2_module: 'Level 2 Modul',
    permissions: 'Berechtigungen',
    add_role: 'ROLLE HINZUFÜGEN',
    roles: 'Rollen',
    role_settings: 'Rolleneinstellungen',
    edit_role: 'Rolle bearbeiten',
    account_take_effect:
      'Die Aktualisierung wird nach der erneuten Anmeldung wirksam.',
    algorithms: 'Algorithmen',
    delete_role_confirm: 'Das Löschen der Rolle ist endgültig.',
    //translate permissions list
    'Dashboard Module': 'Modul Dashboard',
    'Charts Module': 'Modul Berichte',
    'Goals Module': 'Modulvorgaben',
    'Manage Module': 'Modul verwalten',
    Group: 'Gruppe',
    Individual: 'Individuell',
    'Voiding Chart': 'Miktionsprotokoll',
    'Pad Fill Profile Chart': 'IKM-Füllprofil-Diagramm',
    'Body Position Chart': 'Körperpositionsdiagramm',
    'Smartz Devices Chart': 'Smartz®-Gerätediagramm',
    'Pad Fill Profile': 'IKM-Füllprofil',
    'Skin Care': 'IKM Tragedauer',
    Position: 'Position',
    Temperature: 'Temperatur',
    Admin: 'Admin',
    'My Account': 'Mein Konto',
    Role: 'Rolle',
    Organisation: 'Organisation',
    'Data Privacy': 'Datenschutz',
    View: 'Anzeigen',
    Share: 'Teilen',
    Print: 'Drucken',
    Save: 'Speichern',
    'Reset Password': 'Passwort zurücksetzen',
    Delete: 'Löschen',
    Add: 'Hinzufügen',
    Edit: 'Bearbeiten',
    Fall: 'Sturz',
    //end translate permissions list
    check_fall: 'STURZ ÜBERPRÜFEN',
    position_goal_not_allow_off:
      'Positionsvorgabe kann nicht AUSGESCHALTET werden, wenn Sturzvorgabe EINGESCHALTET ist, um die Sicherheit zu verbessern.',
    falls: 'Sturzerkennung',
    falls_detection_and_notification: 'Sturzerkennung und Benachrichtigung',
    falls_detection: 'Sturzerkennung',
    detect_falls: 'Sturzerkennung erkennen',
    on: 'EIN',
    position_goal: 'Positionsvorgabe',
    has_been_turn_on:
      'wurde EINGESCHALTET, um die Sturzerkennung zu ergänzen und die Sicherheit zu verbessern.',
    last_fall: 'Letzter Sturz',
    last_week: 'Letzte Woche',
    three_months: '3 Monate',
    time_to_change: 'Zeit zum Wechseln',
    sent_successfully: 'Erfolgreich gesendet',
    sent_failed: 'Senden fehlgeschlagen',
    send_email: 'E-Mail senden',
    send: 'Senden',
    add_email: 'E-Mail-Adresse hinzufügen',
    saved_successfully: 'Erfolgreich gespeichert',
    saved_failed: 'Speichern fehlgeschlagen',
    deleted_successfully: 'Erfolgreich gelöscht',
    deleted_failed: 'Löschen fehlgeschlagen',
    email: 'E-Mail-Adresse',
    please_enter_email_address: 'Bitte E-Mail-Adresse eingeben',
    please_enter_the_correct_email_address:
      'Bitte geben Sie die korrekte E-Mail-Adresse ein',
    time_in_a_pad_goal: 'VORGABE DER ZEIT IN EINEM IKM',
    time_goal: 'ZEITVORGABE',
    body_temperature: 'Körpertemperatur',
    upper_goal_limit: 'Obergrenze der Vorgabe',
    lower_goal_limit: 'Untergrenze der Vorgabe',
    time_of_fall: 'Zeitpunkt des Sturzes',
    heart_rate: 'Herzfrequenz',
    max_heart_rate: 'Max. Herzfrequenz',
    min_heart_rate: 'Min. Herzfrequenz',
    average_heart_rate: 'Durchschnittliche Herzfrequenz',
    oximetry: 'Oximetrie',
    blood_o2_saturation: 'O2-Sättigung des Blutes',
    min_oximetry: 'Min. Oximetrie',
    max_oximetry: 'Max. Oximetrie',
    average_oximetry: 'Durchschnittliche Oximetrie',
    respiration: 'Atmung',
    breathing_pattern: 'Atemmuster',
    breath: 'Atem',
    respiration_vs_oximetry: 'Atmung vs. Oximetrie',
    min_respiration: 'Min. Atmung',
    max_respiration: 'Max. Atmung',
    average_respiration: 'Durchschnittliche Atmung',
    balance: 'Gleichgewicht',
    falls_and_balance: 'Sturzerkennung und Gleichgewicht',
    loss_of_balance_events: 'Gesamtübersicht des Verlusts des Gleichgewichts',
    sudden_changes_in_body_orientation:
      'Plötzliche Veränderungen in der Körperorientierung',
    goal_limit: 'Grenze der Vorgabe',
    last_event_exceeding_goal:
      'Letztes Ereignis, das die Vorgabe überschreitet',
    balance_loss_events: 'Gesamtübersicht des Verlusts des Gleichgewichts',
    per_7_days: 'Pro 7 Tage',
    body_lean_over_7_days: 'Neigung des Körpers über 7 Tage',
    chart_shows_tendency:
      'Diagramm zeigt die Tendenz des Körpers, sich während der Bewegung in eine bestimmte Richtung zu neigen',
    lean_forward: 'Vorwärts lehnen',
    backwards: 'rückwärts',
    forward: 'vorwärts',
    vitals: 'VITALDATEN',
    vitals_signs: 'VITALPARAMETER',
    spo2: 'SPO2',
    pulse: 'Puls',
    abdominal_movement: 'Abdominale Bewegung',
    min: 'min.',
    attach_the_pod:
      'Bringen Sie den Pod erst an, wenn das IKM bereits am Patienten angebracht ist. Die Nichtbeachtung dieser Anweisung könnte dazu führen, dass aufgrund der Bewegung und Handhabung des IKM fälschlicherweise ein Sturz registriert wird, bevor es am Patienten angebracht wird.',
    body_positions_analysis: 'Analyse der Körperposition',
    repositioning: 'Neupositionierung',
    stayed_in_one_position: 'in einer Position verblieben',
    change_in_position: 'Positionsänderung',
    no_pod_data: 'keine Pod-Daten',
    possible_intervention: 'Möglicher Eingriff',
    body_position_goal: 'VORGABE FÜR DIE KÖRPERPOSITON',
    tap_to_setup_body_position_goals:
      'Antippen, um Zielvorgaben für die Körperposition festzulegen',
    time_blocks_greater_than: 'Zeitblöcke größer als',
    will_be_highlighted: 'werden hervorgehoben',
    chart_filters: 'DIAGRAMMFILTER',
    tap_to_show: 'zum Anzeigen antippen',
    tap_to_hide: 'zum Ausblenden antippen',
    notifications: 'Benachrichtigungen',
    time_to_reposition: 'Zeit bis zur Neupositionierung',
    hour: 'Stunde',
    hours: 'Stunden',
    minute: 'Minute',
    minutes: 'Minuten',
    sensor_disconnected: 'Sensor getrennt',
    from: 'VON',
    to: 'AN',
    quick_start_guide: 'Schnellstartanleitung',
    wet_outside: 'Nässe außerhalb des IKM',
    attend_fall: 'STURZ BEHANDELN',
    reclip_pod: 'POD ERNEUT ANBRINGEN',
    change_position: 'POSITION ÄNDERN',
    replace_battery: 'BATTERIE AUSTAUSCHEN',
    allowed_time_exceeded: 'Zulässige Zeit überschritten',
    wetness_outside: 'Nässe außerhalb',
    analysing_pad: 'IKM wird analysiert',
    pad_not_selected: 'IKM nicht ausgewählt',
    silence: 'Stummschalten',
    silence_confirm_box_title: 'Sturzerkennung stummschalten',
    silence_confirm_box_content:
      'Wenn Sie die Sturzbenachrichtigung stummschalten, wird sie aus dem Gruppen-Dashboard entfernt. Möchten Sie fortfahren? ',
    yes: 'JA',
    no: 'NEIN',
    pad_status: 'IKM-STATUS',
    check_pad_fill: 'IKMFÜLLUNG ÜBERPRÜFEN',
    patient_profile: 'PATIENTENPROFIL',
    periods: 'Zeiträume',
    products: 'Produkte',
    active: 'aktiv',
    manage_user_profile: 'Benutzerprofil verwalten',
    sign_out: 'Abmelden',
    view: 'Anzeigen',
    groups: 'Gruppen',
    groups_in_view: 'Gruppen in der Anzeige',
    total_daily_profile: 'Gesamttagesprofil',
    day_profile: 'Profil für tagsüber',
    night_profile: 'Profil für nachts',
    pad_fill_profile_goal: 'VORGABE FÜR DAS IKM-FÜLLPROFIL',
    tap_to_setup_pad_fill_profile_goals:
      'Antippen, um die Zielvorgaben für das IKM-Füllprofil festzulegen',
    insufficient_data: 'Unzureichende Daten',
    last_7_days: 'Letzte 7 Tage',
    pad_removed: 'IKM entfernt',
    view_groups: 'Gruppe(n) anzeigen',
    minimum_voiding_into_pad: 'Minimale Entleerung in das IKM',
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',
    disconnected_desc:
      'Es wird darauf gewartet, dass der Pod erneut am IKM angebracht wird ...',
    pod_unclipped_desc:
      'Es wird darauf gewartet, dass der Pod wieder in Reichweite kommt ...',
    password_policy: 'Richtlinie zu Passwörtern',
    position_chart: 'Positionsdiagramm',
    hi_everyone: 'Hallo allerseits!',
    voiding_chart_email_content:
      'Das per E-Mail versandte Miktionsprotokoll kann von Ihnen überprüft werden.',
    pad_fill_profile_chart_email_content:
      'Das per E-Mail versandte IKM-Füllprofil-Diagramm kann von Ihnen überprüft werden.',
    position_chart_email_content:
      'Das per E-Mail versandte Positionsdiagramm kann von Ihnen überprüft werden.',
    temperature_chart_email_content:
      'Das per E-Mail versandte Temperaturdiagramm kann von Ihnen überprüft werden.',
    heare_rate_chart_email_content:
      'Das per E-Mail versandte Herzfrequenzdiagramm kann von Ihnen überprüft werden.',
    oximtry_chart_email_content:
      'Das per E-Mail versandte Oximetrie-Diagramm kann von Ihnen überprüft werden.',
    respiration_chart_email_content:
      'Das per E-Mail versandte Atmungsdiagramm kann von Ihnen überprüft werden.',
    balance_chart_email_content:
      'Das per E-Mail versandte Gleichgewichtsdiagramm kann von Ihnen überprüft werden.',
    smartz_chart_email_content:
      'Das per E-Mail versandte Smartz®-Diagramm kann von Ihnen überprüft werden.',
    best_regards: 'Mit freundlichen Grüßen',
    the_simavita_team: 'Das Smartz Operations Team',
    days: 'Tage',
    weeks: 'Wochen',
    years: 'Jahre',
    reset_all_users_passwords: 'Alle Benutzer-Passwörter zurücksetzen',
    reset_all_passwords: 'Alle Passwörter zurücksetzen',
    reset: 'Zurücksetzen',
    change_password: 'Passwort ändern',
    old_password: 'Altes Passwort',
    lowercase: 'Kleinbuchstabe',
    uppdercase: 'Großbuchstabe',
    number: 'Zahl',
    please_select: 'Bitte auswählen',
    loading_chart: 'Diagramm wird geladen',
    please_wait: 'Einen Augenblick bitte ...',
    edit_user: 'Benutzer bearbeiten',
    add_user: 'Benutzer hinzufügen',
    edit_group: 'Gruppe bearbeiten',
    add_group: 'Gruppe hinzufügen',
    group_name: 'Gruppenname',
    group_name_required: 'Gruppenname ist erforderlich',
    patients: 'Patienten',
    manage_user_account: 'Benutzerkonto verwalten',
    filter_by_group_name: 'Nach Gruppenname filtern',
    delete_group_warning:
      'Bitte beachten Sie, dass das Löschen einer Gruppe endgültig ist.',
    delete_patient_warning:
      'Das Löschen von Patienten und personenbezogenen Daten ist endgültig.',
    pod_mac: 'Pod Mac',
    pod_serial_number: 'Pod-Seriennummer',
    add_patient: 'Patient hinzufügen',
    edit_patient: 'Patient bearbeiten',
    alias: 'Pseudonym',
    alias_required: 'Pseudonym ist erforderlich',
    pod_mac_required: 'Pod Mac ist erforderlich',
    pod_serial_number_required: 'Seriennummer ist erforderlich',
    please_enter_capital_letters_and_numbers:
      'Bitte geben Sie Großbuchstaben und Zahlen ein',
    select_date_range: 'Datumsbereich auswählen',
    start_time: 'Startzeit',
    end_time: 'Endzeit',
    select_groups_to_collate:
      'Wählen Sie die Gruppe(n) aus, die zusammengestellt werden soll(en)',
    all_groups: 'Alle Gruppen',
    export_report: 'Bericht exportieren',
    export_csv: 'CSV exportieren',
    reports: 'Berichte',
    please_complete_form: 'Bitte füllen Sie das Formular aus',
    nodes: 'Knoten',
    network_map: 'Netzwerkkarte',
    network_utilisation: 'Netzwerkauslastung',
    notify_me_when_nodes_offline:
      'Mich benachrichtigen, wenn (ein) Knoten offline ist/sind',
    zoom_in_chart: 'Zoom im Diagramm aktivieren',
    latency: 'Latenz',
    lan: 'LAN',
    wifi_infrastructure: 'WLAN-Infrastruktur',
    pods: 'Pods',
    data: 'Daten',
    packet_less: 'Datenpaket geringer',
    secondary_connection: 'Sekundäre Verbindung',
    rssi: 'RSSI',
    no_nodes: 'Keine Knoten',
    share_code: 'Code teilen',
    //Start translation from here.
    active_patients: 'Aktive Patienten',
    archived_patients: 'Archivierte Patienten',
    archive: 'archivieren',
    restore: 'wiederherstellen',
    are_you_sure: 'Sind Sie sicher?',
    you_about_to_archive: `Sie sind dabei, zu archivieren`,
    default_group_not_delete: 'Die Standardgruppe kann nicht gelöscht werden',
    patients_belong_to: 'Patienten, zugehörig zu',
    move: 'Verschieben',
    warning: 'Warnung',
    add_node: 'Knoten hinzufügen',
    edit_node: 'Knoten bearbeiten',
    room_name: 'Name des Zimmers',
    mac_address: 'MAC-Adresse',
    delete_node_warning: 'Das Löschen des Knotens ist endgültig. ',
    mac_address_required: 'MAC-Adresse ist erforderlich',
    room_name_required: 'Name des Zimmers ist erforderlich',
    mac_address_format_warning:
      'Das eingegebene MAC-Adressformat ist falsch. Bitte in Form von XX: XX:XX:XX:XX:XX eingeben',
    node_management: 'Knotenverwaltung',
    time_period: 'Zeitraum',
    manufacturer: 'Hersteller',
    product: 'Produkt',
    please_select_time_period: 'Bitte wählen Sie den Zeitraum aus',
    please_select_manufacturer: 'Bitte wählen Sie den Hersteller aus',
    please_select_product: 'Bitte wählen Sie das Produkt aus',
    no_data: 'Keine Daten vorhanden',
    please_select_manufacturer_first:
      'Bitte wählen Sie zuerst den Hersteller aus',
    details: 'Details',
    time_period_warning:
      'Die Tageszeit und die Nachtzeit müssen die gesamten 24 Stunden des Tages abdecken.',
    reset_successfully: 'Zurücksetzen erfolgreich',
    region: 'Region',
    select_at_least_one_group: 'Wählen Sie mindestens eine Gruppe aus',
    node: 'Knoten',
    pods_location: 'Pods-Standort',
    pod_id: 'Pod-ID',
    accelerometer: 'Beschleunigungsmesser',
    senser: 'Sensor',
    gain: 'Zunahme',
    offset: 'Verschiebung',
    failed_to_connecte_smartz_service:
      'Verbindung zum Smartz<sup>®</sup>-Dienst fehlgeschlagen',
    add_to_smartz_group_failed:
      'Hinzufügen zum Smartz-Gruppendienst fehlgeschlagen',
    retry: 'Nochmals versuchen',
    customization: 'Anpassung',
    customization_settings: 'Anpassungseinstellungen',
    colors: 'Farben',
    font: 'Schriftart',
    logo: 'Logo',
    login_background: 'Login-Hintergrund',
    apply: 'Für die',
    theme: 'aktuelle Website',
    to_current_site: 'anwenden',
    customize_theme_text:
      'Passen Sie das Aussehen der Website an Sind Sie auf Abenteuer aus?',
    create_a_custom_theme: 'Erstellen Sie ein benutzerdefiniertes Thema',
    custom_theme: 'Benutzerdefiniertes Thema',
    preview: 'Vorschau',
    reset_customization_settings:
      'Alle Konfigurationen wurden auf den Standardwert zurückgesetzt',
    drag_the_logo_here: 'Ziehen Sie das Logo hierher',
    or: 'oder',
    click_upload: 'klicken Sie auf Hochladen',
    only_image_files_can_be_uploaded:
      'Es können nur JPG/PNG-Dateien hochgeladen werden',
    the_size_of_the_uploaded_image_cannot_exceed:
      'Die Größe des hochgeladenen Bildes darf 2 MB nicht überschreiten',
    please_sign_out_to_preveiw_effect:
      'Melden Sie sich nach dem Hochladen ab, um die Wirkung in der Vorschau anzuzeigen',
    please_enter_theme_name: 'Bitte geben Sie den Namen des Themas ein',
    failed: 'Fehlgeschlagen',
    add_pod: 'Pod hinzufügen',
    edit_pod: 'Pod bearbeiten',
    filter_pod: 'Nach Pod-MAC-Adresse filtern',
    filter_node: 'Nach Knoten, MAC-Adresse und Zimmer filtern',
    delete_pod_warning: 'Das Löschen des Pod ist endgültig. ',
    delete_theme_warning: 'Das Löschen des Themas ist endgültig.',
    apply_theme_warning:
      'Hinweis: Dieser Vorgang wendet die benutzerdefinierten Einstellungen auf den Domainnamen an. Seien Sie bitte vorsichtig.',
    please_enter_domain_name: 'Bitte geben Sie den Domainnamen ein',
    domain_name_incorrect: 'Das Format des Domainnamens ist falsch',
    apply_successfully: 'Erfolgreich angewendet',
    location: 'Standort',
    manufacturer_code: 'Herstellercode',
    node_mac_address: 'MAC-Adresse des Knotens',
    expired: 'Abgelaufen',
    please_select_location: 'Bitte Standort auswählen',
    filter_patients: 'Patienten filtern',
    monitor_patient: 'Patient überwachen',
    patient: 'Patient',
    room: 'Zimmer',
    assign: 'Zuweisen',
    unassign: 'Zuweisung aufheben',
    unassign_patient_permanent:
      'Bitte beachten Sie, dass das Aufheben der Zuweisung des Patienten endgültig ist.',
    you_able_to_unassign: `Sie sind dabei, die Zuweisung aufzuheben`,
    node_mac_address_required: 'MAC-Adresse des Knotens ist erforderlich',
    not_assigned: 'Nicht zugewiesen',
    assign_node_to: 'Knoten zuweisen zu',
    create_user: 'Benutzer erstellen',
    email_is_required: 'E-Mail-Adresse ist erforderlich',
    created_successfully: 'Erfolgreich erstellt',
    manage_patient_data: 'PATIENTENDATEN VERWALTEN',
    selected_patient: 'AUSGEWÄHLTER PATIENT',
    archive_patient: 'PATIENT ARCHIVIEREN',
    archive_patient_warning:
      'Patientendaten archivieren. Der Patient erscheint nicht mehr im System, bis er wiederhergestellt ist.',
    archive_patient_data: 'Patientendaten archivieren',
    restore_patient: 'Patient wiederherstellen',
    restore_patient_warning:
      'Archivierte Daten wiederherstellen, damit sie in diesem System angezeigt werden können.',
    archive_date: 'Archivierungsdatum',
    restore_patient_data: 'Patientendaten wiederherstellen',
    delete_account: 'KONTO LÖSCHEN',
    user_accounts: 'Benutzerkonten',
    selected_site: 'Ausgewählte Website',
    no_site: 'Keine Website',
    drag_the_login_background_here: 'Ziehen Sie den Login-Hintergrund hierher',
    drag_the_menu_background_here: 'Ziehen Sie den Menü-Hintergrund hierher',
    patient_data_privacy: 'DATENSCHUTZ BEI PATIENTEN',
    edit_theme: 'Thema bearbeiten',
    drag_the_main_content_background_here:
      'Ziehen Sie den Hintergrund des Hauptinhalts hierher',
    opacity_desc:
      'Opazität (Transparenz von im Hintergrund gesperrten Inhalten)',
    menu_bg: 'Menü-Hintergrund',
    main_content_bg: 'Hintergrund des Hauptinhalts',
    background: 'Hintergrund',
    account: 'Konto',
    super_admin: 'Super-Admin',
    help: 'Hilfe',
    filter_by_user_name: 'nach Benutzernamen filtern',
    drag_the_top_nav_background_here:
      'Ziehen Sie den Hintergrund des oberen Navigationsbereichs hierher',
    apply_theme: 'Thema anwenden',
    apply_to_this_domain: 'Auf diese Domain anwenden',
    crop_image: 'Bild zuschneiden',
    enlarge: 'Vergrößern',
    narrow: 'Schmälern',
    left_rotation: 'Linksdrehung',
    right_rotation: 'Rechtsdrehung',
    remove_image: 'Bild entfernen',
    operation_area: 'Betriebsbereich',
    preview_area: 'Vorschaubereich',
    logo_shape: 'Logo-Form',
    show_as_circle: 'Als kreisförmiges Symbol anzeigen',
    history: 'Verlauf',
    status: 'Status',
    download: 'Herunterladen',
    export: 'Exportieren',
    created_date: 'Erstellungsdatum',
    next: 'Weiter',
    register: 'Registrieren',
    back: 'Zurück',
    create_an_organisation: 'Eine Organisation erstellen',
    please_enter_organisation_name:
      'Bitte geben Sie den Namen der Organisation ein',
    address: 'Adresse',
    please_enter_organisation_address:
      'Bitte geben Sie die Adresse der Organisation ein',
    phone: 'Telefon',
    please_enter_organisation_phone:
      'Bitte geben Sie die Telefonnummer der Organisation ein',
    description: 'Beschreibung',
    add_facility: 'Einrichtung hinzufügen',
    edit_facility: 'Einrichtung bearbeiten',
    facility: 'Einrichtung',
    no_room: 'Kein Zimmer',
    facility_name: 'Name der Einrichtung',
    add_room: 'Zimmer hinzufügen',
    room_already_exists: 'Zimmer bereits vorhanden',
    home: 'Home',
    signed_into: 'Angemeldet bei',
    please_select_an_organisation: 'Bitte wählen Sie eine Organisation aus',
    hello: 'Hallo',
    useful_features: 'Nützliche Funktionen',
    attention: 'Aufmerksamkeit',
    quick_actions: 'Schnellzugriff',
    no_patient_warning:
      'Es gibt keine zu überwachenden Patienten. Fügen Sie jetzt Patienten hinzu, um loszulegen.',
    add_patient_quick_action_desc:
      'Fügen Sie einen zu überwachenden Patienten hinzu',
    welcome_to_the_group_dashboard: 'Willkommen im Gruppen-Dashboard',
    show_me_more: 'Mehr anzeigen',
    add: 'hinzufügen',
    welcome_to_patient_management: 'Willkommen im Patientenmanagement',
    update_patient: 'Patient aktualisieren',
    update_patient_quick_action_desc: `Patientendetails aktualisieren`,
    change_patient_products: `Produkte des Patienten ändern`,
    change_patient_products_quick_action_desc:
      'Vom Patienten verwendetes Produkt ändern',
    reassign_pod_to_patient: 'Pod dem Patienten neu zuweisen',
    reassign_pod_quick_action_desc: `Pod des Patienten auswechseln`,
    monitor_patient_with_a_node: 'Knoten dem Patienten zuweisen',
    monitor_patient_with_a_node_quick_action_desc:
      'Knoten eines Patienten überprüfen',
    welcome_to_the_administration_section:
      'Willkommen im Administrationsbereich',
    invite_user: 'Benutzer einladen',
    invite_user_quick_action_desc: 'Einen Benutzer zum System einladen',
    remove_or_archive_patient: 'Patient entfernen/archivieren',
    remove_or_archive_patient_quick_action_desc:
      'Einen Patienten aus dem Dashboard entfernen',
    profile: 'Profil',
    not_monitored: 'nicht überwacht',
    rounds: 'Runden',
    //translate permissions list
    'Super Admin': 'Super-Admin',
    Algorithms: 'Algorithmen',
    Customisation: 'Anpassung',
    Account: 'Konto',
    'Roles & Permissions': 'Rollen und Berechtigungen',
    'Network Map': 'Netzwerkkarte',
    'Network Utilisation': 'Netzwerkauslastung',
    'Buildings & Rooms': 'Einrichtungen und Zimmer',
    Manufacturers: 'Hersteller',
    Settings: 'Einstellungen',
    Profile: 'Profil',
    Devices: 'Geräte',
    Nodes: 'Knoten',
    'Pods Location': 'Pods-Standort',
    'Share Code': 'Code teilen',
    Users: 'Benutzer',
    'User Accounts': 'Benutzerkonten',
    'Invite User': 'Benutzer einladen',
    Patients: 'Patienten',
    'Monitor Patient': 'Patient überwachen',
    'Patient Data Privacy': 'Datenschutz für Patienten',
    Archive: 'Archivieren',
    Restore: 'Wiederherstellen',
    'Patients Module': 'Patienten-Modul',
    Export: 'Exportieren',
    History: 'Verlauf',
    Report: 'Bericht',
    Monitor: 'Überwachen',
    //translate permissions list
    time_zone: 'Zeitzone',
    please_select_time_zone: 'Bitte wählen Sie eine Zeitzone aus',
    add_facility_and_room: 'EINRICHTUNG UND ZIMMER HINZUFÜGEN',
    filter_by_facility_name: 'nach Name der Einrichtung filtern',
    floor: 'Etage',
    please_enter_facility_name: 'Bitte geben Sie den Namen der Einrichtung ein',
    please_enter_floor_name: 'Bitte geben Sie den Namen der Etage ein',
    please_enter_room_number: 'Bitte geben Sie die Zimmernummer ein',
    facility_name_already_exists:
      'Der Name der Einrichtung ist bereits vorhanden',
    floor_name_should_be_unique: 'Der Name der Etage sollte eindeutig sein',
    room_number_should_be_unique: 'Die Zimmernummer sollte eindeutig sein',
    add_manufacturer: 'Hersteller hinzufügen',
    filter_by_manufacturer_code_or_name:
      'nach Herstellercode oder -name filtern',
    enabled: 'Aktiviert',
    delete_manufacturer_warning: 'Das Löschen des Herstellers ist endgültig. ',
    please_enter_role_name: 'Bitte geben Sie die Bezeichnung der Rolle ein',
    please_choose_one_as_the_current_organization:
      'Bitte wählen Sie eine als aktuelle Organisation aus',
    display_name: 'Anzeigename',
    assign_roles: 'Rollen zuweisen',
    remove: 'Entfernen',
    please_assign_a_role_to_the_user:
      'Bitte weisen Sie dem Benutzer eine Rolle zu',
    send_invitation: 'Einladung senden',
    invitation_email_sent: 'Einladung per E-Mail gesendet.',
    facility_and_Floor_and_Room: 'Einrichtung, Etage und Zimmer',
    export_patient: 'Patient exportieren',
    export_patient_history_data: 'Verlaufsdaten des Patienten exportieren',
    export_patient_data: 'Patientendaten exportieren',
    export_report_success_text: `Export der Patientendaten läuft. Sie werden per E-Mail benachrichtigt, sobald sie verfügbar sind. Überprüfen Sie den Fortschritt auf der Registerkarte „Dateien”. `,
    select_patients: 'Patienten auswählen',
    export_in_progress: 'Export läuft',
    continue: 'fortfahren',
    please_enter_patient_name: `Bitte geben Sie den Namen des Patienten ein`,
    please_enter_patient_alias: `Bitte geben Sie das Pseudonym des Patienten ein`,
    facility_and_room: 'Einrichtung und Zimmer',
    create_new: 'Neu erstellen',
    add_facility_and_floor_and_room: 'Einrichtung, Etage und Zimmer hinzufügen',
    select_facility_floor_room: 'Einrichtung, Etage und Zimmer auswählen',
    choose_one: 'Eines auswählen',
    enter_manually: 'Manuell eingeben',
    pod_serial_number_format_incorrect:
      'Das eingegebene Format der Pod-Seriennummer ist falsch.',
    add_a_manufacturer_to_continue:
      'Fügen Sie einen Hersteller hinzu, um fortzufahren',
    please_enter_subscription_code: 'Bitte geben Sie einen Abonnement-Code ein',
    added_successfully: 'Erfolgreich hinzugefügt',
    select_a_patient: 'Wählen Sie einen Patienten aus',
    assign_products: 'Produkte zuweisen',
    assign_pod: 'Pod zuweisen',
    assign_node: 'Knoten zuweisen',
    we_have_created_a_default_facility:
      'Wir haben eine Standardeinrichtung, eine Standardetage und ein Standardzimmer für Ihre Organisation geschaffen',
    if_you_want_edit_this_facility: `Wenn Sie die Informationen dieser Einrichtung bearbeiten möchten, tippen Sie auf`,
    or_you_can: 'Oder Sie können',
    already_registered: 'Bereits registriert',
    sign_up: 'Registrieren',
    create_account: 'Konto erstellen',
    pod_and_diaper: 'Pod und IKM',
    pod_and_diaper_content: ` <p class="underline">Befolgen Sie diese Schritte, um den Pod mit der IKM zu verbinden:</p>
          <ul>
            <li>
Linieren Sie die drei Streifen der Smart-IKM mit den drei Goldnadeln des Smart-Pods
            </li>
            <li>Bringen Sie den Pod an der <span class="underline">Vorderseite</span> der Smart-IKM an</li>
            <li>
Grünes Licht blinkt schnell für 3 Sekunden, dann dauerhaft für 1 Sekunde = gute Verbindung
            </li>
            <li>
Kein grünes Blinklicht nach 20 Sekunden = keine Verbindung. Trennen Sie den Smart-Pod ab und bringen Sie ihn erneut an
            </li>
            <li>Wenn bei ordnungsgemäßer Verbindung kein Licht blinkt, ist die Batterie leer</li>
          </ul>`,
    home_landing_slide1_title: 'Willkommen im Gesundheitsportal',
    home_landing_slide1_content: `
      <p>Mit dem Gesundheitsportal können Sie die Kontinenz und das Wohlbefinden Ihres Patienten überwachen.</p>
      <p>Überwachen Sie Patientengruppen, um Maßnahmen zu priorisieren und eine individuelle zentrierte Versorgung zu gewährleisten.</p>`,
    home_landing_slide2_title: 'Smart-IKM-Technologie',
    home_landing_slide2_content: `
      <p>Wenn ein Smart-Pod an eine Smart-IKM angeschlossen ist, überträgt er Daten über ein Netzwerk, wodurch der Betreuer den Patienten über das Gesundheitsportal überwachen kann.</p>
      <p>Sobald Ihr Patient im System zugewiesen ist, wissen Sie auf einen Blick, wann Sie die IKM wechseln müssen, und können sich Verlaufsdaten anzeigen lassen. Sie können auch ganz einfach Zielvorgaben setzen und benachrichtigt werden, wann Sie die IKM wechseln, die Position Ihres Patienten ändern, die Flüssigkeitsausscheidung überwachen, die Umgebungstemperatur messen und mögliche Sturzerkennung überprüfen müssen.</p>`,
    home_landing_slide4_title: 'Fügen Sie den ersten Patienten hinzu',
    home_landing_slide4_content: `
      <p>Fügen Sie zunächst einen Patienten hinzu, indem Sie die Schaltfläche „Schnellzugriff” verwenden und den Anweisungen folgen.</p>
      <p>Das System unterstützt Sie während des gesamten Vorgangs der Einstellung des Patienten.</p>`,
    home_landing_slide5_title: 'Schnellzugriff',
    home_landing_slide5_content: `
      <p>Damit können Sie auf häufige Maßnahmen wie das Hinzufügen eines Patienten zugreifen.</p>
      <p>Ein Assistent führt Sie durch alle notwendigen Schritte. </p>`,
    dashboard_landing_slide1_title: 'Willkommen im Gruppen-Dashboard',
    dashboard_landing_slide1_content: `
      <p>Überwachen Sie alle Ihre Patienten im Dashboard und erkennen Sie, wann Ihre Patienten Aufmerksamkeit benötigen.</p>
      <p>Ihre Arbeitsbelastung kann reduziert werden, indem Sie den visuellen Aufforderungen des Systems folgen.</p>`,
    dashboard_landing_slide2_title: 'Willkommen im Gruppen-Dashboard',
    dashboard_landing_slide2_content: `<ul>
      <li>Es werden Symbole angezeigt, die den Status des Patienten ausweisen</li>
      <li>Es gibt zwei Bereiche auf dem Dashboard, den Bereich <span class="underline">Maßnahme erforderlich</span> und den Bereich <span class="underline">Monitoring</span></li>
      <li>Um die Arbeitsbelastung zu reduzieren und die Patientenversorgung zu verbessern, konzentrieren Sie sich auf die Symbole <span class="underline">„Maßnahme erforderlich”</span> mit hoher Priorität</li>
    </ul>`,
    dashboard_landing_slide3_title: 'Der IKMstatus',
    dashboard_landing_slide3_content: `
      <p>Der Der IKMstatus und „Zeit zum Wechseln” wird mittels eines Ampelsystems dargestellt:</p>
      <ul>
        <li><span class="red-text"><span class="underline">Rot</span> = IKM wechseln,</span> d. h. nasse IKM, die auslaufen kann</li>
        <li><span class="yellow-text"><span class="underline">Gelb</span> = Wechsel der IKM vorbereiten,</span> d. h. IKM erreicht Kapazität</li>
        <li><span class="green-text"><span class="underline">Grün</span> = keine Maßnahme</span>, d. h. trockene IKM</li>
      </ul>`,
    dashboard_landing_slide4_title: 'Andere Status',
    dashboard_landing_slide4_content: `
      <p>Um die Kontinuität der Pflege zu gewährleisten, beachten Sie alle auf dem Dashboard angezeigten Maßnahmen:</p>
      <ul>
        <li>Das Symbol „Verbindung verloren” zeigt an, dass die Bluetooth-Verbindung verloren gegangen ist und es zu Datenverlust kommen kann.</li>
        <li>Das Symbol „Position wechseln“ zeigt an, dass es an der Zeit ist, die Position des Patienten zu ändern.</li>
      </ul>`,
    dashboard_landing_slide5_title: 'Optimieren',
    dashboard_landing_slide5_content: `<p>Überprüfen Sie die Gruppen-Dashboard-Benachrichtigungen, um Ihre tägliche Patientenversorgung zu optimieren.</p>`,
    dashboard_landing_slide6_title: 'Bereichsfilter',
    dashboard_landing_slide6_content: `
      <p>Der Bereichsfilter ist eine optionale Funktion, mit der Sie einen ausgewählten Bereich der Einrichtung auf Ihrem Dashboard anzeigen können. Verwenden Sie die Bereichsfilter mit Vorsicht, da sie vorhandene Patienten ausblenden und nur die Filterauswahl anzeigen.</p>
      <p>So wählen Sie den neuen Bereichsfilter aus: </p>
      <ol>
        <li>Wählen Sie das Dropdown-Menü für Bereiche aus</li>
        <li>Tippen Sie auf „Neuer Bereich“</li>
        <li>Geben Sie den „Namen des Bereichsfilters” ein</li>
        <li>Wählen Sie das Gebäude aus</li>
        <li>Markieren Sie den Bereich, die Etage und die Zimmernummern</li>
        <li>Überprüfen Sie Ihre Filterauswahl im Feld „Zusammenfassung der Filter”</li>
        <li>Antippen, um diesen Bereichsfilter zu speichern</li>
        <li>Wählen Sie im Dropdown-Menü den Bereichsfilter oder die Option „Bereiche verwalten“ aus</li>
      </ol>
    `,
    home_landing_slide3_title: 'Pod und IKM',
    home_landing_slide3_content: `
    <ul>
      <li>Pod an IKM anschließen</li>
      <li>Beobachten Sie die grünen LED-Leuchten auf dem Pod</li>
      <li>Erhalten Sie Aktualisierungen des Status des Patienten</li>
    </ul>`,
    patient_landing_slide1_title: 'Individuelles Dashboard',
    patient_landing_slide1_content: `
      <p>Wenn Sie einen einzelnen Patienten auswählen, zeigt ein neues Dashboard den Status aller derzeit überwachten Funktionen an, einschließlich des verwendeten Smart-Pods und der verwendeten IKM.</p>
      <p>Wählen Sie einen anderen Patienten aus, der im Dropdown-Menü angezeigt werden soll.</p>`,
    patient_landing_slide2_title: `Willkommen im Patientenbereich`,
    patient_landing_slide2_content: `
      <p>Das individuelle Dashboard zeigt den aktuellen Status des Patienten an.</p>
      <p>Der Bereich „Berichte” erfasst Gesundheitstrends.</p>
      <p>Bestimmte Zielvorgaben können im Bereich „Zielvorgaben” festgelegt werden, und Benachrichtigungen können erhalten werden.</p>`,
    patient_landing_slide3_title:
      'Zugriff auf individuelle Dashboards, Berichte und Zielvorgaben',
    patient_landing_slide3_content: `<p>Auf der linken Seite des Dashboards können Sie auf den Bereich „Patient, Berichte und Zielvorgaben” zugreifen.</p>`,
    patient_landing_slide4_title: 'Patient/Individuelles Dashboard',
    patient_landing_slide4_content: `
      <ul>
        <li>Jeder Patient hat sein eigenes Dashboard</li>
        <li>Erforschen Sie den individuellen Status Ihres Patienten</li>
        <li>Wechseln Sie zwischen Patienten, indem Sie sie mit dem Dropdown-Pfeil auswählen</li>
      </ul>`,
    patient_landing_slide5_title: 'Berichte',
    patient_landing_slide5_content: `
      <p>Es gibt verschiedene Berichte, mit denen Sie Daten anzeigen und interpretieren können, darunter:</p>
      <ul>
        <li>Miktionsprotokoll</li>
        <li>IKM-Füllprofil</li>
        <li>Positionsdiagramm.</li>
      </ul>
      <p>Sie können diese ausdrucken und weitergeben, um die Behandlung Ihres Patienten zu überprüfen und anzupassen.</p>`,
    patient_landing_slide6_title: 'Zielvorgaben',
    patient_landing_slide6_content: `
      <p>Um die Versorgung Ihres Patienten weiter zu verbessern, können spezifische Zielvorgaben festgelegt werden. Diese umfassen:</p>
      <ul>
        <li>Patientenlagerung</li>
        <li>IKM Tragedauer</li>
        <li>IKM-Füllprofil</li>
        <li>Temperatur</li>
        <li>Sturzerkennung.</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>Wählen Sie den Patienten aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>Mit der Auswahl des Datumsbereichs können maximal 7 Tage angezeigt werden.</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>Das Miktionsprotokoll bietet eine ganzheitliche Ansicht des Entleerungsverlaufs Ihres Patienten.</li>
        <li>Bei der Verwendung des Smartz<sup>®</sup>-Systems werden Echtzeitdaten im Miktionsprotokoll angezeigt.</li>
        <li>In diesem Diagramm können Sie zwischen der Anzeige des IKM-Zyklus oder der Übersicht über Entleerungsereignisse wechseln.</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>Symbole können durch Auswahl gefiltert werden.</li>
        <li>Die Legende unter dem Miktionsprotokoll zeigt die im Diagramm angezeigten Symbole.</li>
        <li>Tippen Sie auf „Diagrammfilter“, um die Symbole auszuwählen oder abzuwählen, die Sie anzeigen möchten.</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>Durch das Anzeigen dieses Diagramms können Sie:</p>
      <ul>
        <li>mögliche Zeiten identifizieren, in denen der Patient erfolgreich auf die Toilette gehen kann</li>
        <li>ob die IKM innerhalb eines akzeptablen Zeitraums gewechselt wurde</li>
        <li>die Anzahl der Padwechsel über den Zeitraum</li>
        <li>teilen und Ihr Diagramm ausdrucken.</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>Das Ereignisdiagramm zeigt alle Gesamtübersicht für den Status von IKM, Pod, Zielvorgaben und Netzwerk an.</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>Das „Gesamttagesprofil” zeigt die Gesamtmenge der Flüssigkeit an, die über einen Zeitraum von 24 Stunden in das IKM entleert wurde.</li>
        <li>Die tägliche Ausscheidung in die IKM wird über jedem Tropfen angezeigt.</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>Das Symbol auf der rechten Seite zeigt das „durchschnittliche” Volumen der Ausscheidung über den ausgewählten Zeitraum von Tagen an.</li>
        <li>Aktivieren Sie diese Option, um die Profile „Tag“ und „Nacht“ getrennt anzuzeigen.</li>
        <li>Das Diagramm zeigt an, ob eine Vorgabe für das IKM-Füllprofil festgelegt oder ausgelöst wurde.</li>
        <li>Wählen Sie bei Bedarf aus, die Vorgabe festzulegen.</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>Das Gesamttagesprofil zeigt die gesamte Flüssigkeitsmenge an, die während eines Zeitraums von 24 Stunden in die IKM entleert wurde.</li>
        <li>Wenn sich die Ausscheidung von Urin beim Patienten verringert, kann dies ein Indikator sein, die Flüssigkeitszufuhr zu erhöhen.</li>
        <li>Teilen und drucken Sie Ihr Diagramm aus.</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>Das Diagramm zeigt die Zeitdauer in einer Körperposition über eine ausgewählte Anzahl von Tagen an.</li>
        <li>Bewegen Sie den Mauszeiger über das Diagramm, um weitere Details anzuzeigen.</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>Tippen Sie auf „Diagrammfilter“, um die Positionen auszuwählen oder abzuwählen, die Sie anzeigen lassen möchten.</li>
        <li>Das Diagramm hebt hervor, ob eine Vorgabe für die Körperposition festgelegt wurde.</li>
        <li>Antippen, um die Vorgabe festzulegen.</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>Wenn Sie einen Patienten haben, der für Hautschäden/Druckverletzungen anfällig ist, werden Sie durch Festlegen der Vorgabe darüber informiert, wann es Zeit ist, die Position des Patienten zu ändern.</li>
        <li>Bei Auswahl von „Drucken” werden die Positionen und die Zeiträume mit zusätzlichen Details aufgelistet. </li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>Gehen Sie zum Bereich „Glühbirnen” für weitere Details.</li>
      </ul>`,
    body_position_goal_help_title: 'Vorgabe für die Patientenlagerung',
    body_position_goal_slide1_content: `
      <ul>
        <li>Durch Festlegen der Vorgabe wird der Betreuer darüber informiert, wann es Zeit ist, die Position des Patienten zu ändern.</li>
        <li>Verwenden Sie diese Vorgabe, wenn Sie einen Patienten haben, der für Hautschäden/Druckverletzungen anfällig ist.</li>
        <li>Die Reduzierung der Zeit in einer Position könnte helfen, Druckverletzungen zu lindern.</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den Patienten aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler, um die maximale Zeitdauer auszuwählen, während der sich Ihr Patient tagsüber bzw. nachts in einer bestimmten Position befinden soll.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>Sie haben nun die maximale Zeitdauer ausgewählt, während der sich Ihr Patient in einer bestimmten Position befinden soll, und Sie werden im Bereich „Maßnahme erforderlich” benachrichtigt, wann Sie sie ändern müssen.</li>
      </ul>`,
    skin_management_goal_help_title: 'Vorgabe für das Hautmanagement',
    skin_management_goal_slide1_content: `
      <ul>
        <li>Ein regelmäßigerer Wechsel der IKM kann dazu beitragen, die Haut des Patienten trocken zu halten und Hautirritationen zu reduzieren.</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den Patienten aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler, um die maximale Zeitdauer auszuwählen, während der Ihr Patient eine IKM tragen soll.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>Sie werden nun im Abschnitt „Maßnahme erforderlich” benachrichtigt, wenn Sie die IKM des Patienten wechseln müssen.</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Umgebungstemperatur des Pods',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>Mit dieser Vorgabe können Sie die minimale/maximale Umgebungstemperatur des Pods einstellen.</li>
        <li>Legen Sie sich diese Vorgabe fest, wenn Sie Bedenken bezüglich der Temperaturschwankung Ihres Patienten haben.</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den Patienten aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Um über eine Temperaturänderung in der Umgebung des Pods benachrichtigt zu werden, bewegen Sie den Schieberegler, um die minimalen und maximalen Temperaturen auszuwählen.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>Sie werden nun im Abschnitt „Maßnahme erforderlich” benachrichtigt, wenn die Umgebungstemperatur des Pod außerhalb des eingestellten Bereichs liegt.</li>
      </ul>`,
    pad_fill_profile_goal_help_title: 'Vorgabe für das IKM-Füllprofil',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>Mit dieser Vorgabe können Sie das minimale/maximale Entleerungsvolumen in die IKM einstellen, wenn Sie befürchten, dass Ihr Patient eine geringe Urinausscheidung hat.</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den Patienten aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler, um das bevorzugte Volumen für den Tag bzw. für die Nacht auszuwählen.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>Sie werden nun im Bereich „Maßnahme erforderlich” benachrichtigt, wenn das Ausscheidungsvolumen Ihres Patienten in die IKM außerhalb des eingestellten Bereichs liegt.</li>
      </ul>`,
    fall_detection_goal_help_title: 'Vorgabe für die Sturzerkennung',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>Diese Vorgabe benachrichtigt Sie, wenn Ihr Patient gestürzt ist.</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den Patienten aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler in die Position EIN, um die Vorgabe zu aktivieren.</li>
        <li>Standardmäßig ist die „Zeit in Position” eingeschaltet. </li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>Wenn ein Sturz aufgetreten ist, wird ein blinkendes Symbol im Abschnitt „Maßnahme erforderlich” angezeigt.</li>
        <li>Wenn Sie den Sturz in „Individuelles Dashboard” stummschalten, wird das Symbol aus dem Haupt-Dashboard entfernt.</li>
      </ul>`,
    voiding_chart_help_dialog_title: 'Verwenden des Miktionsprotokoll',
    pad_fill_profile_chart_help_dialog_title: 'Verwenden des IKM-Füllprofils',
    position_chart_help_dialog_title: 'Verwenden des Körperpositionsdiagramms',
    pad_fill_profile_goal_help_dialog_title:
      'Vorgabe für das IKM-Füllprofil festlegen',
    skin_care_goal_help_dialog_title:
      'Vorgabe für IKM Tragedauer-Management festlegen',
    position_goal_help_dialog_title:
      'Vorgabe für die Patientenlagerung festlegen',
    temperature_goal_help_dialog_title:
      'Vorgabe für die Umgebungstemperatur des Pods festlegen',
    fall_detection_goal_help_dialog_title:
      'Vorgabe für die Sturzerkennung festlegen',
    invite_user_quick_action_desc_for_home_landing:
      'Laden Sie einen Betreuer ein, dieser Organisation beizutreten',
    archived_successfully: 'Erfolgreich archiviert',
    verification_passed: 'Verifizierung erfolgreich',
    verification_failed: 'Verifizierung fehlgeschlagen',
    verify_error_msg_801:
      'Ihre Einladung ist abgelaufen oder nicht mehr gültig. Um eine weitere Einladung anzufordern, wenden Sie sich an den Administrator der Organisation.',
    verify_error_msg_802:
      'Ihre Einladung ist für diesen Benutzer nicht gültig. Wenn Sie als anderer Benutzer angemeldet waren, bevor Sie diese Einladung angenommen haben. Bitte melden Sie sich ab und versuchen Sie es erneut.',
    verify_error_msg_803: 'Benutzer nicht gefunden.',
    verify_error_msg_804: 'Einladungscode nicht gefunden.',
    verify_error_msg_805:
      'Sie sind bereits Mitglied der Organisation, der Sie beitreten möchten.',
    verify_success_msg: 'Willkommen in der neuen Organisation.',
    verify_error_msg_not_sign_in: `Bitte melden Sie sich an, um der Organisation beizutreten. <br/> Wenn Sie noch kein Konto haben, registrieren Sie sich bitte zuerst.`,
    verify_error_msg_620: 'Der Code ist ungültig oder abgelaufen',
    verify_error_msg_622: `Konnte der Organisation nicht beitreten. Der Einladungscode ist für diese E-Mail-Adresse ungültig.`,
    failed_to_get_chart_data: 'Diagrammdaten konnten nicht gesendet werden.',
    filter: 'Filter',
    please_select_facility_first: 'Bitte wählen Sie zuerst die Einrichtung',
    areas: 'Bereich(e)',
    floors: 'Etage(n)',
    new_area: 'Neuer Bereich',
    manage_areas: 'Bereiche verwalten',
    show_all_facilities: 'Alle Einrichtungen anzeigen',
    show_all_areas: 'Alle Bereiche anzeigen',
    new_area_filter: 'Neuer Bereichsfilter',
    area_filter_name: 'Name des Bereichsfilters',
    area: 'Bereich',
    please_enter_area_filter_name:
      'Bitte geben Sie den Namen des Bereichsfilters ein',
    please_select_facility: 'Bitte wählen Sie die Einrichtung aus',
    please_select_floor_and_room:
      'Bitte wählen Sie die Etage und das Zimmer aus',
    please_select_organisation: 'Bitte wählen Sie die Organisation aus',
    filter_summary: 'Filterzusammenfassung',
    show_patients_from: 'Patienten anzeigen von',
    in: 'in',
    and: 'und',
    belonging_to: 'zugehörig zu',
    select_an_area: 'Wählen Sie einen Bereich aus',
    manage_area: 'Bereich verwalten',
    please_select_area_filter: 'Bitte wählen Sie einen Bereichsfilter aus',
    delete_area: 'Bereich löschen',
    keep_in_mind_delete_area: 'Das Löschen des Bereichs ist endgültig. ',
    facility_information: 'Informationen zur Einrichtung',
    floor_information: 'Informationen zur Etage',
    room_information: 'Informationen zum Zimmer',
    number_of_floors: 'Anzahl der Etagen',
    please_enter_number_of_floors: 'Bitte geben Sie die Anzahl der Etagen ein',
    number_of_rooms: 'Anzahl der Zimmer',
    please_enter_number_of_rooms: 'Bitte geben Sie die Anzahl der Zimmer ein',
    add_floor: 'Etage hinzufügen',
    remove_floor: 'Etage entfernen',
    remove_room: 'Zimmer entfernen',
    select_area_warning: `Der Bereich und die Etage können nicht gleichzeitig ausgewählt werden. <br/>Wählen Sie nur eines davon aus.`,
    manage_area_filter: 'Bereichsfilter verwalten',
    no_area: 'Kein Bereich',
    there_are_no_patient_to_manage:
      'Es gibt keine Patienten, die zu verwalten sind.',
    default_themes: 'Standardthemen',
    custom_themes: 'Individuelle Themen',
    background_color: 'Hintergrundfarbe',
    top_navigation_background_color:
      'Hintergrundfarbe des oberen Navigationsbereichs',
    top_nav_text_color: 'Textfarbe des oberen Navigationsbereichs',
    top_nav_active_text_color:
      'Aktive Textfarbe des oberen Navigationsbereichs',
    sidebar_background_color: 'Hintergrundfarbe der Seitenleiste',
    sidebar_active_block_background_color:
      'Aktive Block-Hintergrundfarbe der Seitenleiste',
    sidebar_text_color: 'Textfarbe der Seitenleiste',
    sidbar_active_block_text_color: 'Aktive Block-Textfarbe der Seitenleiste',
    card_title_background_color: 'Hintergrundfarbe des Kartentitels',
    card_title_text_color: 'Textfarbe des Kartentitels',
    card_body_background_color: 'Hintergrundfarbe des Kartentexts',
    card_button_color: 'Farbe der Schaltfläche der Karte',
    room_number: 'Zimmernummer',
    verify_invitation: 'EINLADUNG VERIFIZIEREN',
    well_done: 'Gut gemacht!',
    you_have_updated_the_patient: `Sie haben die Daten des Patienten aktualisiert.`,
    you_have_created_the_patient:
      'Sie haben einen Patienten hinzugefügt, der im Gruppen-Dashboard angezeigt werden kann.',
    tell_me_more: 'Mehr dazu erfahren',
    registered_pods: 'Registrierte Pods',
    registered_nodes: 'Registrierte Knoten',
    select: 'Auswählen',
    start: 'Start',
    end: 'Ende',
    floor_name: 'Name der Etage',
    sign_in_failed: 'Anmeldung fehlgeschlagen',
    skin_care_goal_title: 'Zeit im IKM',
    'Event Chart': 'Smartz-Ereignisdiagramm',
    account_information: 'Kontoinformationen',
    given_name: 'Vorname',
    surname: 'Nachname',
    please_enter_pod_serial_number:
      'Bitte geben Sie die Seriennummer des Pod ein',
    manufacturer_subscription_code: `Abonnement-Code des Herstellers`,
    remove_node_mac_address: 'MAC-Adresse des Knotens entfernen',
    link_a_node_mac_address: 'Eine MAC-Adresse des Knotens verknüpfen',
    export_data: 'Daten exportieren',
    available_files: 'Verfügbare Dateien',
    export_patient_data_desc:
      'Klicken Sie auf die nachstehende Schaltfläche, um die folgenden Verlaufsdaten zu exportieren:',
    dry_diaper: 'Trockene IKM',
    wet_diaper: 'Nasse IKM',
    change_diaper: 'IKM wechseln',
    external_humidity: 'Feuchtigkeit außen',
    smartz_events: 'Smartz<sup>®</sup>-Gesamtübersicht',
    smartz_events_chart_email_content:
      'Das per E-Mail versandte Ereignisdiagramm kann von Ihnen überprüft werden.',
    reposition: 'Neupositionierung',
    fall: 'Sturz',
    cycle: 'Zyklus',
    pad_cycle: 'IKM-Zyklus',
    off_body: 'außerhalb des Körpers',
    pad_status_legend: 'IKM-Status',
    analysing_diaper_legend: 'IKM wird analysiert',
    dry_wet_change_diaper: 'IKM trocken/nass/wechseln',
    pod_status: 'Pod-Status',
    goal_status: 'Zielvorgaben-Status',
    diaper_removed_legend: 'IKM entfernt',
    time_to_change_legend: 'Zeit zum Wechseln',
    out_of_range_legend: 'außerhalb des Bereichs',
    diaper_not_selected: 'IKM nicht ausgewählt',
    duration: 'Dauer',
    small_void: 'Geringe Entleerung',
    medium_void: 'Mittelmäßige Entleerung',
    large_void: 'Umfangreiche Entleerung',
    view_mode: 'Anzeigemodus',
    voids_only: 'nur Entleerungen',
    void_event_size: 'Größe des Entleerungsereignisses',
    pad_start: 'IKM-Start',
    pad_end: 'IKM-Ende',
    exceed_goal_time: 'Zeitliche Vorgabe überschritten',
    reclip: 'erneut anbringen',
    unstable_readings: 'Instabile Messwerte',
    not_selected: 'Nicht ausgewählt',
    analysing: 'Wird analysiert',
    create_organisation: 'Organisation erstellen',
    all_times_are_in: 'Alle Zeiten sind in',
    failed_to_get_goal_settings:
      'Fehler beim Abrufen der festgelegten Zielvorgaben',
    next_steps: 'Nächste Schritte',
    video: 'Video',
    monitor_warning:
      'Monitoring ist nicht verfügbar, da kein Smartz<sup>®</sup>-Pod zugewiesen ist',
    find_further_information: 'Weitere Informationen finden Sie',
    here: 'hier',
    savePatientPodErrMsg: `Die angegebene Pod-Seriennummer ist in dieser Organisation nicht vorhanden.`,
    savePatientNodeErrMsg: `Die angegebene MAC-Adresse des Knotens ist in dieser Organisation nicht vorhanden.`,
    already_registered_desc:
      'Bitte melden Sie sich mit dem Benutzernamen und dem Passwort an, mit denen Sie sich ursprünglich registriert haben.',
    create_account_desc:
      'Bitte geben Sie einen Benutzernamen und ein Passwort ein, um ein Benutzerkonto zu erstellen und auf die Website zuzugreifen.',
    signing_in: 'Anmeldung läuft',
    signing_out: 'Abmeldung läuft',
    welcome: 'Willkommen',
    top: 'Oben',
    facility_or_building: 'Einrichtung/Gebäude',
    keep_at_least_one_facility: 'Behalten Sie mindestens eine Einrichtung bei',
    keep_at_least_one_floor: 'Behalten Sie mindestens eine Etage bei',
    keep_at_least_one_room: 'Behalten Sie mindestens ein Zimmer bei',
    rename: 'Umbenennen',
    domain_name: 'Domainname',
    subscription_code: 'Abonnement-Code',
    events: 'Gesamtübersicht',
    no_pods_text: 'Es sind keine Pods in dieser Organisation registriert.',
    no_nodes_text: 'Es sind keine Knoten in dieser Organisation registriert.',
    confirm_deletion: 'Löschen bestätigen.',
    confirm_archive: 'Archivieren bestätigen',
    account_deletion: 'Löschen des Kontos',
    delete_account_warning:
      'Das Löschen des Benutzerkontos und der personenbezogenen Daten ist endgültig.',
    deletion: 'Löschung',
    restoring_patient: 'Patient wird wiederhergestellt',
    font_family: 'Schriftfamilie',
    font_size: 'Schriftgröße',
    font_color: 'Schriftfarbe',
    main_title: 'Haupttitel',
    title: 'Titel',
    small_title: 'Untertitel',
    body_text: 'Textkörper',
    body_text_small: 'Textkörper (klein)',
    supplementary_text: 'Ergänzender Text',
    primary_text: 'Haupttext',
    regular_text: 'Normaler Text',
    secondary_text: 'Nachrangiger Text',
    placeholder_text: 'Platzhalter-Text',
    top_nav_background: 'Hintergrund des oberen Navigationsbereichs',
    edit_facility_and_floor_and_room:
      'Einrichtung, Etage und Zimmer bearbeiten',
    please_select_buildings: 'Bitte Gebäude auswählen',
    please_select_floors: 'Bitte Etagen auswählen',
    please_select_rooms: 'Bitte Zimmer auswählen',
    facility_setup: 'Festlegen der Einrichtung',
    view_a_patient_by_selecting_from_drop_down_menu:
      'Einen Patienten anzeigen, indem Sie aus dem Dropdown-Menü auswählen.',
    monitoring: 'Monitoring',
    silencing: 'Schweigen',
    fall_detection: 'Sturzerkennung',
    wetness: 'Feuchtigkeit',
    pod: 'Pod',
    diaper: 'IKM',
    time_in_diaper: 'Zeit in IKM',
    setup_area_filter_desc:
      'Führen Sie diese Schritte aus, um einen neuen Flächenfilter einzurichten.',
    max_time_in_pad: 'Maximale Zeit im IKM',
    max_time_in_pos: 'Max. Zeit in Position',
    change_in: 'Änderung in',
    not_monitoring: 'Nicht überwachen',
    exceed_allowed_time: 'Überschreitung der zulässigen Zeit',
    Pseudonymized: 'Pseudonymisiert',
    Anonymized: 'Anonymisiert',
    pseudonymized_permission_warning:
      'Pseudonymisierte Patientenrechte und Patientenrechte können nicht gleichzeitig ausgewählt werden. Bitte wählen Sie eine davon aus.',
    anonymized_permission_warning:
      'Die anonymisierte Patientenberechtigung und die Patientenbearbeitungsberechtigung können nicht gleichzeitig ausgewählt werden. Bitte wählen Sie eine davon aus.',
    please_select_one_product:
      'Bitte wählen Sie eines Tages- oder Nachtprodukt',
    none: 'Keine',
    invitation: 'Einladung',
    has_invited: 'hat eingeladen',
    to_join: 'beitreten',
    invitation_desc:
      'Wenn Sie bereits ein Konto mit dieser E-Mail-Adresse haben, melden Sie sich bitte an, um Mitglied zu werden.',
    if_not_please: 'Wenn nicht, bitte',
    accept: 'akzeptieren',
    decline: 'Abfall',
    // The following text is used in German, but not in other languages
    hinweis: 'HINWEIS',
    body_position_goal_for_de: 'Patientenlagerung',

    acceptable_temperature_range: 'akzeptabler Temperaturbereich',
    temperature_alert_off: 'Der Temperaturalarm ist ausgeschaltet',
    temperature_alert_on:
      'Der Temperaturalarm ist so eingestellt, dass er aktiviert wird, wenn die Temperatur',
    below: 'unten',
    above: 'oben',
    partial_body_repositioning: 'Teilweise Neupositionierung des Körpers',
    minimum_angle_change: 'minimale Winkeländerung',
    degrees: 'grad',
    goal_time_exceed: 'Zielzeit überschritten',
    allowed_time_exceed: 'Zulässige Zeit überschritten',
    safe_time_exceed: 'Sichere Zeitüberschreitung',
    brief_not_used: 'IKM nicht verwendet',
    monitor_unstable_readings: 'Überwachen Sie instabile Messwerte',
    leakage: 'Leakage',
    new_battery: 'Neue Batterie',
    exceed_safe_time_in_pad: 'Überschreitung der sicheren Zeit im IKM',
    predicted_change_time: 'Voraussichtliche Änderungszeit',
    total_time: 'Gesamtzeit',
    exceed_safe_time: 'Überschreiten Sie die sichere Zeit',
    consider_using_smartz_product:
      'Erwägen Sie die Verwendung eines Smartz-Produkts',
    non_smartz_product_in_use: 'Es wird kein Smartz-Produkt verwendet',
    product_not_selected: 'Produkt nicht ausgewählt',
    assign_smartz_product_to_patient: 'Smartz-Produkt dem Patienten zuweisen',
    wait_a_moment: 'Moment mal...',
    find_patient: 'Patienten finden'
  },
  country: 'German',
  language: 'Deutsch',
  abb_name: 'de'
}
